/* eslint-disable no-prototype-builtins */
import { publish, EVENTS } from '@sendible/event-manager';

window.permissionsManager = {

  initialize() {
    const user_status = $current_user.user_status.toLowerCase();
    const isSuspended = user_status.indexOf('suspended') !== -1;
    const isTrial = user_status.indexOf('trial') !== -1;
    const isTrialExpired = user_status.indexOf('trial expired') !== -1;

    const permissions = (typeof $current_user.permission_profile !== 'undefined')
      ? $current_user.permission_profile.permissions
      : [];

    // setup variables
    this.initialized = false;
    this.profile = $current_user.profile;
    this.overridePermissions = false;
    this.approval_from = true;
    this.permissionsSetOnLoad = (typeof $current_user.permission_profile !== 'undefined');
    this.canNavigate = {
      navigation: true,
      status: $current_user.user_status,
    };
    this.isTrial = isTrial;

    if (isTrialExpired || isSuspended) {
      this.canNavigate.navigation = false;
    }

    // check white label
    this.isWhiteLabel = window.appConfig.isWhiteLabel;

    // process override
    this.processOverride();

    // process approval form
    if ($current_user.hasOwnProperty('approval_from')) {
      if ($current_user.approval_from.length > 0) {
        this.approval_from = false;
      }
    }

    // set permissions
    this.setPermissions(permissions);

    // check if user is disabled or inactive
    switch ($current_user.user_status) {
      case 'Disabled':
        advancedLocalStorage.setItem(
          's_loginMessage',
          window.lookup('Your account is disabled. Please contact your administrator about re-enabling it.'),
        );
        loginContext.logoutAllUsers();
        break;
      case 'Inactive':
        advancedLocalStorage.setItem(
          's_loginMessage',
          window.lookup('Your account is inactive. Please contact your administrator about re-activating it.'),
        );
        loginContext.logoutAllUsers();
        break;
      default:
    }

    // setup triggers and the rules array
    this.setupTriggers();

    this.initialized = true;
  },

  isAdmin() {
    if (this.profile === 'Administrator') {
      return true;
    }
    return false;
  },

  // checks the users status (Disabled, Inactive, Trial Expired, Suspended)
  checkAccount() {
    let locationHash;
    let initialFragment;

    switch ($current_user.user_status) {
      case 'Disabled':
        advancedLocalStorage.setItem(
          's_loginMessage',
          window.lookup('Your account is disabled. Please contact your administrator about re-enabling it.'),
        );
        loginContext.logoutAllUsers();

        return false;

      case 'Inactive':
        advancedLocalStorage.setItem(
          's_loginMessage',
          window.lookup('Your account is inactive. Please contact your administrator about re-activating it.'),
        );
        loginContext.logoutAllUsers();

        return false;

      case 'Trial Expired':
        if (this.profile === 'Administrator') {
          locationHash = window.location.hash.trim().replace('#', '');
          initialFragment = storageUtils.getCookieOrLocalStorageItem('s_initialFragment');

          if (initialFragment === 'manage/extendtrial') {
            publish(EVENTS.CHANGE_PAGE, '#manage/extendtrial');
            advancedLocalStorage.removeItem('s_initialFragment');
            Backbone.history.loadUrl();
          } else if (locationHash == 'manage/subscription') {
            Backbone.history.loadUrl();
          } else {
            publish(EVENTS.CHANGE_PAGE, '#manage/subscription');
          }

          this.canNavigate = {
            navigation: false,
            status: $current_user.user_status,
          };

          return false;
        }

        advancedLocalStorage.setItem(
          's_loginMessage',
          window.lookup('Your account has been suspended. Please contact your administrator.'),
        );

        loginContext.logoutAllUsers();

        break;

      case 'Paused':
        if (this.profile === 'Administrator') {
          advancedLocalStorage.setItem(
            's_loginMessage',
            window.lookup('Your account is paused. Please contact support about re-enabling it.'),
          );
        } else {
          advancedLocalStorage.setItem(
            's_loginMessage',
            window.lookup('Your account is paused. Please contact your administrator about re-enabling it.'),
          );
        }

        loginContext.logoutAllUsers();

        return false;
      case 'Suspended':
        if (this.profile === 'Administrator') {
          publish(EVENTS.CHANGE_PAGE, '#manage/subscription');
          Backbone.history.loadUrl();

          this.canNavigate = {
            navigation: false,
            status: $current_user.user_status,
          };
        } else {
          advancedLocalStorage.setItem(
            's_loginMessage',
            window.lookup('Your account has been suspended. Please contact your administrator.'),
          );
          loginContext.logoutAllUsers();
        }

        return false;
      default:
    }

    return true;
  },

  // cretaes a list of triggers and a rule array that contains permissions and their associated triggers
  setupTriggers() {
    this.triggers = {
      topBar: 'render:top-bar',
      topNavigation: 'render:top-navigation',
      engageLeftSidebar: 'render:engage-left-sidebar',
      manageLeftSidebar: 'render:manage-left-sidebar',
      composeView: 'render:compose-view',
      calendarView: 'render:calendar-view',
      priorityInboxToolbar: 'render:priority-inbox-toolbar',
      streamToolbar: 'render:stream-toolbar',
      wizard: 'render:wizard',
    };

    const { triggers } = this;

    this.rules = [
      {
        name: 'messages.create',
        triggers: [triggers.topNavigation],
      },
      {
        name: 'messages.scheduling',
        triggers: [triggers.calendarView, triggers.composeView, triggers.engageLeftSidebar],
      },
      {
        name: 'messages.queues',
        triggers: [triggers.composeView, triggers.engageLeftSidebar],
      },
      {
        name: 'manage.lists',
        triggers: [triggers.composeView, triggers.manageLeftSidebar],
      },
      {
        name: 'manage.content',
        triggers: [triggers.topNavigation, triggers.manageLeftSidebar],
      },
      {
        name: 'reporting',
        triggers: [triggers.topNavigation],
      },
      {
        name: 'services',
        triggers: [triggers.topNavigation, triggers.priorityInboxToolbar, triggers.streamToolbar, triggers.wizard],
      },
      {
        name: 'view.pricePlan',
        triggers: [triggers.topBar],
      },
      {
        name: 'view.adminSettings',
        triggers: [triggers.topBar],
      },
      {
        name: 'view.manageAdminNav',
        triggers: [],
      },
      {
        name: 'view.wizardAddUsers',
        triggers: [],
      },
      {
        name: 'view.manageAdminNav',
        triggers: ['redirect:manage-admin'],
      },
    ];
  },

  // process wether the user can override permissions
  processOverride() {
    if (this.profile === 'Administrator' || this.permissionsSetOnLoad === false) {
      this.overridePermissions = true;
    } else {
      this.overridePermissions = false;
    }
  },

  // checks if the users profile has changed
  checkProfile(newProfile) {
    if (newProfile !== this.profile) {
      this.profile = newProfile;

      this.processOverride();
      this.runAllTriggers();
    }
  },

  getCurrentProfileType() {
    return loginContext.getCurrentDetails().profile;
  },

  // check if the user can navigate the app
  checkCanNavigate() {
    if (this.canNavigate.navigation) {
      return true;
    }
    const locationHash = window.location.hash.trim().replace('#', '');

    setTimeout(() => {
      if (locationHash !== 'manage/subscription') {
        publish(EVENTS.CHANGE_PAGE, '#manage/subscription');
        Utils.setActiveView('manage-subscription');
      }
    });

    return false;
  },

  // trigger all triggers
  runAllTriggers() {
    _.each(this.triggers, (trigger) => {
      Backbone.trigger(trigger);
    });
  },

  // setup permissions (only called at app startup)
  setPermissions(permissions) {
    this.userPermissions = [];
    // eslint-disable-next-line
    for (const permissionsIndex in permissions) { 
      this.userPermissions.push(permissions[permissionsIndex].permission_code);
    }
  },

  // adds a list of permissions and runs triggers on changed permissions
  setUpdatedPermissions(permissions, changedPermissions) {
    const triggerArray = [];

    this.userPermissions = [];
    // eslint-disable-next-line
    for (const permissionsIndex in permissions) {
      this.userPermissions.push(permissions[permissionsIndex].permission_code);
    }

    _.each(this.rules, (rule) => {
      if (changedPermissions.indexOf(rule.name) !== -1) {
        _.each(rule.triggers, (trigger) => {
          if (triggerArray.indexOf(trigger) === -1) {
            triggerArray.push(trigger);
          }
        });
      }
    });

    _.each(triggerArray, (trigger) => {
      Backbone.trigger(trigger);
    });
  },

  // takes a new permissions array and compares it to the current permissions, returning the changed (added or removed)
  processNewPermissions(newPermissionsObject) {
    const newPermissions = [];

    // look permissions creating a 1d array of new permissions
    _.each(newPermissionsObject, (permission) => {
      newPermissions.push(permission.permission_code);
    });

    const changedPermissions = _.union(_.difference(this.userPermissions, newPermissions), _.difference(newPermissions, this.userPermissions));

    if (changedPermissions.length > 0 && this.initialized) {
      this.setUpdatedPermissions(newPermissionsObject, changedPermissions);
    }
  },

  // checks a permissions name and returns true or false
  checkPermission(permissionCodeName) {
    switch (permissionCodeName) {
      case 'view.pricePlan':
        if (this._canDisplayPricePlan()) {
          return true;
        }
        return false;

      case 'view.adminSettings':
        if (this._canDisplayAdminSettings()) {
          return true;
        }
        return false;

      case 'view.manageAdminNav':
        if (this._canDisplayManageAdminNavigation()) {
          return true;
        }
        return false;

      case 'view.wizardAddUsers':
        if (this._canDisplayWizardAddUsers()) {
          return true;
        }
        return false;

      case 'view.ManageSubscription':
        if (this._canDisplayManageSubscriptionView()) {
          return true;
        }
        return false;
      default:
    }

    if (this.overridePermissions) {
      return true;
    }

    if (this.userPermissions.indexOf(permissionCodeName) > -1) {
      return true;
    }

    return false;
  },

  // checks toolbar specific rules (used externally)
  checkToolbar(itemID) {
    if (itemID === 'new-stream') {
      if (this.checkPermission('services')) {
        return true;
      }
      return false;
    }

    return true;
  },

  /*
    * User type rules:
    * please see google doc "Sendible Web App - Permission Settings"
    * for more details on permissions based on user type
  */
  _canDisplayPricePlan() {
    if (this.isWhiteLabel && this.profile === 'Administrator') {
      return true;
    } if (this.isWhiteLabel) {
      return false;
    }

    if (this.profile === 'Administrator' || this.profile === 'Team Member') {
      return true;
    }

    return false;
  },

  _canDisplayAdminSettings() {
    if (this.profile === 'Administrator') {
      return true;
    }

    return false;
  },

  _canDisplayManageAdminNavigation() {
    if (this.profile === 'Administrator') {
      return true;
    }

    return false;
  },

  _canDisplayManageSubscriptionView() {
    if (this.profile === 'Administrator') {
      return true;
    }

    return false;
  },

  _canDisplayWizardAddUsers() {
    if (this.profile === 'Administrator') {
      return true;
    }

    return false;
  },
};
